// extracted by mini-css-extract-plugin
module.exports = {"partial-star":"styles-module__partial-star___3MnKr"};